export default __webpack_public_path__ + "static/graphics-mobile-38b1041f759a3f520df5fefca55304c0.png";